import { logDetailed } from "./utils";
import { browser } from "./browserDetect";
import { refreshAccessTokenFromBackground, disableRefreshTokenLoop, disableAutologoutEvents } from "./idle";
import { disableRefreshPatientLoop } from "./patientRefresh";
import store from "../store";
//import he from "he";
import router from "../router";

if (window.isOpenedInApp) {
  logAppStartupInfo();
  
  window.checkForAuthenticationInApp = function () {
    logDetailed("appInterface", "window.checkForAuthenticationInApp");
    return store.getters.isAuthenticated;
  }
  logDetailed("appInterface", "root", "finished setting up methods for app->site communication",
    "window.checkForAuthenticationInApp", window.checkForAuthenticationInApp,
    "window.dispatchLoginInApp", window.dispatchLoginInApp,
    "window.dispatchSearchInApp", window.dispatchSearchInApp)
}

// axis://?fn=Robert&ln=Riley
// axis://?uid=kkuser&upass=Password1!&fn=Robert&ln=Riley

window.dispatchSearchInApp = function (query, username, password) {
  let search = parseQuery(query);
  search.uid = search.uid || username;
  search.upass = search.upass || password;

  router.push({path: "/sso", query:{
    ptdob: search.ptdob,
    ptfname: search.ptfname,
    ptlname: search.ptlname,
    ptid: search.ptid,
    uid: search.uid,
    upass: search.upass
  }})
}

function logAppStartupInfo() {
  logDetailed("appInterface", "root", "app to ui communication established");
  logDetailed("appInterface", "root", "browser info", browser);
}

const modmedKeys = {
  "mrn": "ptid",
  "fn": "ptfname",
  "ln": "ptlname",
  "dob": "ptdob",
  "pid": "modmed_pid",
  "vid": "modmed_vid",
}

function parseQuery(query) {
  let dict = {};
  // query string is expected to be in this format: key1=value1&key2=value2&key3=value3
  let pairs = query
    // split groups by &
    .split("&")
    // split pairs by =
    .map(group =>
      group.split("=")
        // each token should be encoded as a uri component
        .map(token => token && decodeURIComponent(token)))
    // keep each pair with a length of exactly 2, where both elements are not-null
    .filter(pair => !!pair && pair.length === 2 && !!pair[0] && !!pair[1]);

  pairs.forEach(pair => {
    let key = modmedKeys[pair[0]] || pair[0];
    dict[key.toLowerCase()] = pair[1]
  });

  return dict;
}

//function dispatchLoginInApp(ID, password) {
//  logDetailed("appInterface", "window.dispatchLoginInApp");
//  if (store.getters.isAuthenticated) {
//    logDetailed("appInterface", "window.dispatchLoginInApp", "already logged in");
//  } else {
//    store.commit("displayStatus", { message: "Logging in automatically", level: "" });
//    store.dispatch("login", { ID, password })
//      .catch(() => store.commit("displayStatus", { message: "Automatic login failed.", level: "error", indefinite: true }))
//      .finally(() => router.push("/"));
//  }
//}

export function onSiteInitializedInApp() {
  logDetailed("appInterface", "onSiteInitializedInApp");
  if (window.onSiteInitializedInApp) 
  {
    window.onSiteInitializedInApp();
    if (store.getters.isAuthenticated) {
      disableRefreshTokenLoop();
      disableAutologoutEvents();
      disableRefreshPatientLoop();
      store.dispatch("logout").then(() => router.push("/"));
    }
  } 
}

window.setBackgroundTimestamp = function () {
  logDetailed("appInterface", "setBackgroundTimestamp");
  store.commit("setBackgroundTimestamp", new Date().getTime());
  disableRefreshTokenLoop();
  disableAutologoutEvents();
  disableRefreshPatientLoop();
}

window.onRefreshTokenInApp = function () {
  logDetailed("appInterface", "onRefreshTokenInApp");
  refreshAccessTokenFromBackground();
}

// backwards compatibility for app versions < v2.0.43
window.setOpenedFromApp = function () {
  logAppStartupInfo();

  store.commit("setOpenedFromApp");

  window.setPopupCB = function (cb) { window.openPopupInApp = cb; }
  window.setRequestPrintInAppCB = function (cb) { window.requestPrintInApp = cb }

window.openPopupInApp = function (msg) {
    window.webkit.messageHandlers.openpopup.postMessage(msg);
  }

  window.requestPrintInApp = function (data, resolve) {
    window.webkit.messageHandlers.requestPrint.postMessage(JSON.stringify(data));
    resolve();
  }

  window.setupRefreshTokenCB = function (cb) { window.onRefreshTokenInApp = cb }
}
